<div
  class="item-label__pill"
  [ngClass]="'item-label__pill--' + itemType"
  [class.item-label__pill--user]="label.type === 'user'"
  [matTooltip]="label.tooltip"
>
  <span>{{ label.label | truncate: 20 }}</span>
</div>
